__turbopack_context__.v({
  "article-card": "YOnXIW_article-card",
  "author": "YOnXIW_author",
  "content": "YOnXIW_content",
  "default-img-wrapper": "YOnXIW_default-img-wrapper",
  "thumbnail": "YOnXIW_thumbnail",
  "thumbnail-wrapper": "YOnXIW_thumbnail-wrapper",
  "title": "YOnXIW_title",
});
